import React, { memo } from "react";
import { RCCGrid, RCCIcon, RCCProgress, RCCTooltip } from "react-common-components";
import UserColumn from "src/components/DefaultColumnsList/User";
import List from "src/components/List";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import { IListOKR } from "./interface";
import OverflowSpan, { DivProgressList, StyledSpan } from "./styles";

const ListOKR: React.FC<IListOKR> = ({
	data,
	options,
	onViewHierarchy,
	openKRs
}) => {
	const { translate, currentLanguage } = useTranslation();

	const colOKR = (row: any) => (
		<OverflowSpan title={`${row.oka001Codigo ? `${row.oka001Codigo} - ` : ""} ${row.oka001Titulo}`}>{row.oka001Codigo ? `${row.oka001Codigo} - ` : ""}{row.oka001Titulo}</OverflowSpan>
	);

	const colUser = (row: any) => (
		<UserColumn 
			name={row.oka001Efa005Nome}
			image={row.oka001Efa005Imagem}
		/>
	);

	const colLevel = (row: any) => (
		<RCCGrid 
			item
			container
			alignItems="center"
			justifyContent="flex-start"
			style={{padding: "0 2px"}}
		>
			{row.oka001Nivel === 1 && (
				<>
					<RCCIcon 
						name="building"
						size={16}
						color="var(--default-color-font)"
						style={{marginRight: "4px"}}
					/>
					<span>
						{translate("Organizacional")}
					</span>
				</>
			)}
			{row.oka001Nivel === 2 && (
				<>
					<RCCIcon 
						name="users"
						size={16}
						color="var(--default-color-font)"
						style={{marginRight: "4px"}}
					/>
					<span>
						{translate("Equipe")}
					</span>
				</>
			)}
			{row.oka001Nivel === 3 && (
				<>
					<RCCIcon 
						name="user"
						size={16}
						color="var(--default-color-font)"
						style={{marginRight: "4px"}}
					/>
					<span>
						{translate("Indivídual")}
					</span>
				</>
			)}
		</RCCGrid>
	);

	const colPeriod = (row: any) => (
		<RCCGrid 
			item
			container
			alignItems="center"
			justifyContent="flex-start"
			style={{
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				overflow: "hidden",
				padding: "0 2px"
			}}
		>
          
			<RCCIcon 
				name="calendar"
				size={16}
				color="var(--default-color-font)"
				style={{marginRight: "4px"}}
			/>
			<span 
				title={row.oka001Periodo ? row.oka001Periodo : `${formatDate(row.oka001Dtinicio, currentLanguage)} - ${formatDate(row.oka001Dtfim, currentLanguage)}`}
				style={{
					textOverflow: "ellipsis",
					flexWrap: "nowrap",
					overflow: "hidden"
				}}
			>
				{row.oka001Periodo ? row.oka001Periodo :
					<>
						{formatDate(row.oka001Dtinicio, currentLanguage)} - {formatDate(row.oka001Dtfim, currentLanguage)}
					</>
				}
			</span>
		</RCCGrid>
	);

	const colPercent = (row: any) => (
		<RCCGrid
			container
			item
			alignItems="center"
		>
			<DivProgressList>
				<RCCProgress 
					layout="line"
					value={row.percent}
					color={row.colorGraph && row.colorGraph !== null && row.colorGraph !== "" ? `#${row.colorGraph}` : undefined}
					styleInline="margin-right: 4px;"
				/>
			</DivProgressList>
			<RCCTooltip
				text={`${translate("Visualizar hierarquia")} ${translate("Nível")}: ${row.level}`}
				color="purple"
				style={{ display: "flex", alignItems: "center"}}
			>
				<RCCIcon 
					name="hierarchy"
					color="var(--purple-lighter)"
					size={20}
					style={{marginRight: "4px", cursor: "pointer"}}
					onClick={() => onViewHierarchy(row.oka001Id)}
				/>
				<StyledSpan style={{marginRight: "4px"}}>
					{row.level}
				</StyledSpan>
			</RCCTooltip>
			<RCCTooltip
				text={translate("Resultados chave")}
				color="grey"
				style={{ display: "flex", alignItems: "center"}}
			>
				<RCCIcon 
					name="key"
					color="var(--grey)"
					size={16}
					style={{marginRight: "4px", cursor: "pointer"}}
					onClick={() => openKRs(row.oka001Id)}
				/>
			</RCCTooltip>
		</RCCGrid>
	);
    
	return(
		<List 
			data={data}
			columns={[{
				idColumn: "oka001Titulo",
				nameColumn: "OKR",
				xs: 12,
				sm: 3,
				justify: "left",
				truncate: true,
				cellRenderer: colOKR
			},{
				idColumn: "oka001Efa005Nome",
				nameColumn: translate("Responsável"),
				xs: 12,
				sm: 2,
				justify: "left",
				cellRenderer: colUser
			},{
				idColumn: "oka001Periodo",
				nameColumn: translate("Período"),
				xs: 12,
				sm: 2,
				justify: "left",
				cellRenderer: colPeriod
			},{
				idColumn: "oka001Nivel",
				nameColumn: translate("Nível"),
				xs: 12,
				sm: 2,
				hidden: ["sm"],
				justify: "left",
				cellRenderer: colLevel
			},
			{
				idColumn: "oka001Taa001Nome",
				nameColumn: translate("Setor"),
				xs: 12,
				sm: 1,
				justify: "left",
				truncate: true
			},
			{
				idColumn: "percent",
				nameColumn: translate("Percentual"),
				justify: "left",
				xs: 12,
				sm: 4,
				md: 2,
				cellRenderer: colPercent
			},
			{
				idColumn: "options",
				nameColumn: " ",
				styleInline: "position: absolute; right: -2px; bottom: 0; width: fit-content !important;",
				hideHeader: true,
				cellRenderer: options
			}]}
			showHeader
		/>
	);};

export default memo(ListOKR);
